module.exports = "images/doc-cotation-add-3.c9a0eeef9adf6814eedd4e2d01f70329.png";